import React from "react";
import AdditionalFieldOptionRepository from "../../../repository/AdditionalFieldOptionRepository";
import StandardFormComponent from "../../basics/form/StandardFormComponent";
import { withRouter } from 'react-router-dom';
import FormToastComponent from "../../basics/FormToastComponent";
import FormHelper from "../../../helpers/FormHelper";
import CheckPermissions from "../../../helpers/CheckPermissions";
import UserRolesEnum from "../../../enums/UserRolesEnum";
import AdditionalFieldOptionTextFormComponent from "./forms/AdditionalFieldOptionTextFormComponent";
import Module from "../../../models/module/Module";
import AdditionalFieldOption from "../../../models/module/additionalfield/AdditionalFieldOption";
import AdditionalFieldOptionContent from "../../../models/module/additionalfield/AdditionalFieldOptionContent";
import { LoaderComponent } from "../../basics/layout";
import { ModuleRepository } from "../../../repository";

class AdditionalFieldOptionFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model !== undefined ? this.props.model : new AdditionalFieldOptionContent(),
            loading: true,
            settings: {},
            isEdit: false,
            roles: this.props.user.roles,
        };

        this.table_ref = React.createRef();

        this.customProps = { ...this.props };
        this.isManager = CheckPermissions.role(this.state.roles, UserRolesEnum.MANAGER) && !CheckPermissions.role(this.state.roles, UserRolesEnum.RESELLER);
    }

    componentDidMount() {
        let promises = [ModuleRepository.get(this.props.match.params.module)];

        if (this.props.get_promise !== undefined) {
            promises.push(this.props.get_promise);
        }

        Promise.all(promises)
            .then(result => {
                Module.set(result[0]?.module);

                let model = this.state.model;
                if (result[1] !== undefined) {
                    model = AdditionalFieldOption.fromJson(result[1].option);
                    let content = model.contents.filter(content => content.language === this.props.match.params.language)[0];

                    model.label = content.label;
                    model.help_text = content.help_text;
                    model.extra_info_website = content.extra_info_website;
                    model.prefix_choices = content.prefix_choices;
                    model.suffix_choices = content.suffix_choices;
                    model.image = content.image;
                    model.content = content.content === '[]' ? { text: null } : JSON.parse(content.content);
                }

                this.setState({
                    loading: false,
                    settings: {
                        type: model.field_type,
                        has_prefix_choices: model.has_prefix_choices,
                        has_suffix_choices: model.has_suffix_choices
                    },
                    model: model,
                    isEdit: model.id
                });
            });
    }

    getBeforeSubmit = (element) => AdditionalFieldOptionTextFormComponent.fields_image_before_submit(element)

    render() {
        if (this.state.loading) return <LoaderComponent />;

        return (
            <StandardFormComponent
                {...this.customProps}
                ref={this.table_ref}
                parent={this}
                className="additional-field"
                validationSchema={AdditionalFieldOption.schema(this.state.settings)}
                model={this.state.model}
                formSubmit={(values, _) => {
                    this.getBeforeSubmit.bind();
                    return this.getBeforeSubmit(this.table_ref.current)
                        .then(() => {
                            if (this.state.isEdit) {
                                return AdditionalFieldOptionRepository.update({ id: values.id, language: this.props.match.params.language, ...values })
                                    .then(() => {
                                        FormToastComponent.successTrans("AdditionalFieldOption", "Default.saved");
                                        this.props.history.push('/modules/' + this.props.match.params.module + '/additionalfields/' + this.props.match.params.field + '/options');
                                    })
                                    .catch(error => FormHelper.handleSubmitError(this, error))
                            } else {
                                return AdditionalFieldOptionRepository.create({ field: this.props.match.params.field, ...values })
                                    .then(() => {
                                        FormToastComponent.successTrans("AdditionalFieldOption", "Default.saved");
                                        this.props.history.push('/modules/' + this.props.match.params.module + '/additionalfields/' + this.props.match.params.field + '/options');
                                    })
                                    .catch(error => FormHelper.handleSubmitError(this, error))
                            }
                        });
                }}
                formErrors={this.state.form_errors}
                fields={AdditionalFieldOptionTextFormComponent.fields(this.state.isEdit, this.state.model, this.state.settings)}
            />
        );
    }
}

export default withRouter(AdditionalFieldOptionFormComponent);